export default "__VITE_ASSET__X5c3MSg0__"